<template>
  <LazyModulesKursusDetail>
    <slot />
  </LazyModulesKursusDetail>
</template>
